var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
var timeInterval = 1.05;
var EmandateLoader = function () {
    var waitTimeUnix = useMemo(function () { return moment().add(timeInterval, "m").subtract(30, "m"); }, []);
    var totalCount = useMemo(function () { return timeInterval * 60; }, []);
    var _a = __read(useState(0), 2), newCount = _a[0], setNewCount = _a[1];
    var _b = __read(useState(), 2), time = _b[0], setTime = _b[1];
    var percetage = useMemo(function () { return Math.floor((newCount / totalCount) * 100); }, [newCount]);
    useEffect(function () {
        setInterval(function () {
            var diff = moment(waitTimeUnix).diff(moment());
            setNewCount(function (count) { return count + 1; });
            setTime(moment(diff).format("mm:ss"));
        }, 1000);
    }, []);
    return (React.createElement("div", { className: "enach-loader" },
        React.createElement("h2", { className: "DMSansMedium_20_500 txt_black-seven taCenter" }, "Redirecting to Exchange"),
        React.createElement("div", { className: "loader-icon" },
            React.createElement("i", { className: "edel-icon-hourglass2" },
                React.createElement("i", { className: "path1" }),
                React.createElement("i", { className: "path2" }),
                React.createElement("i", { className: "path3" }),
                React.createElement("i", { className: "path4" }),
                React.createElement("i", { className: "path5" }),
                React.createElement("i", { className: "path6" }),
                React.createElement("i", { className: "path7" }))),
        React.createElement("div", { className: "grid-1 px-20" },
            React.createElement("div", { className: "mgt-8" },
                React.createElement("span", { className: "d-flex DMSansMedium_12_500 txt_black-seven justify-content-center" },
                    time,
                    " Min"),
                React.createElement("div", { className: "progress-bar-payment mgt-5" },
                    React.createElement("div", { className: "inner-progress", style: { width: "".concat(percetage, "%") } })))),
        React.createElement("p", { className: "DMSans_16_500 txt_blackOne1 lh-nornal" }, "Please wait for we redirect you to the exchange to complete your mandate registration. Alternatively you\u2019ll receive an email from exchange through which you can register your mandate.")));
};
export default EmandateLoader;
